import { Record } from 'immutable';
import { isString } from 'lodash';

const MetaDataRecord = Record({
    code: '',
    count: 0,
    label: '',
    isSelected: false,
    class: '',
    group: '',
    url: '',
    includedItemsValueKeys: [],
});

class MetaData extends MetaDataRecord {
    constructor(conf) {
        let { url } = conf;
        const { label } = conf;

        if (!url && label && isString(label)) {
            url = label.toLowerCase().replace(/ /g, '_');
        }

        super({ ...conf, url });
    }
}

export default MetaData;
